import { Routes, Route } from 'react-router';
import './App.css';
import HomePage from './pages/HomePage';
import ProjectPage from './pages/ProjectPage';
import AboutPage from './pages/AboutPage';
import { useEffect, useState } from 'react';

import { navigatorOpenContext, portfolioPathContext } from './appContext'
import PortfolioPage from './pages/PortfolioPage';

function App() {
  const [navigatorOpen, setNavigatorOpen] = useState(true)
  const [folioPath, setFolioPath] = useState()

  useEffect(() => {
    let path = window.location.pathname.slice(0,10)
    if(path === '/portfolio') {
      setFolioPath(window.location.pathname)
    }
  }, [])
  

  return (
    <div className="App">
      <navigatorOpenContext.Provider value={{navigatorOpen,setNavigatorOpen}}>
          <portfolioPathContext.Provider  value={{folioPath,setFolioPath}}>
            <Routes>
              <Route element={<HomePage />} path='/' />
              <Route element={<ProjectPage />} path='/project' />
              <Route element={<AboutPage />} path='/about' />
              <Route element={<PortfolioPage />} path={folioPath} />
            </Routes>
          </portfolioPathContext.Provider>
      </navigatorOpenContext.Provider>
    </div>
  );
}

export default App;
